import type { Pagination, PriceTier } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'core/price-tiers';

export function getPriceTiers(query?: PriceTier.SearchQuery) {
    return api.get<Pagination<PriceTier>>(rootPath, query);
}

export function getPriceTier(id: number) {
    return api.get<PriceTier.DetailsResponse>(`${rootPath}/${id}`, undefined);
}

export function postPriceTier(data: PriceTier.CreateRequest) {
    return api.post<PriceTier>(rootPath, data);
}

export function putPriceTier(id: number, data: PriceTier.UpdateRequest) {
    return api.put<PriceTier>(`${rootPath}/${id}`, data);
}

export function deletePriceTier({ id }: PriceTier.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
